import React, { useState, useEffect, useRef, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { SmileOutlined } from '@ant-design/icons';
import pickerData from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import styles from './EmojiPickerPortal.module.scss';
const PICKER_WIDTH = 352;
const PICKER_HEIGHT = 435;
const EmojiPickerPortal = ({ disabled, onEmojiSelect }) => {
    const [open, setOpen] = useState(false);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const pickerRef = useRef(null);
    const triggerRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            var _a;
            if (pickerRef.current &&
                !pickerRef.current.contains(event.target) &&
                !((_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
                setOpen(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);
    const updatePosition = useCallback(() => {
        if (!triggerRef.current)
            return;
        const rect = triggerRef.current.getBoundingClientRect();
        let top = rect.bottom + 4;
        let left = rect.right - PICKER_WIDTH;
        // overflow right edge
        if (left + PICKER_WIDTH > window.innerWidth) {
            left = window.innerWidth - PICKER_WIDTH - 8;
        }
        // overflow left edge
        if (left < 8) {
            left = 8;
        }
        // overflow bottom
        if (top + PICKER_HEIGHT > window.innerHeight) {
            top = rect.top - PICKER_HEIGHT - 4;
        }
        // overflow top
        if (top < 8) {
            top = 8;
        }
        setPosition({ top, left });
    }, []);
    const handleToggle = (e) => {
        e.stopPropagation();
        if (disabled)
            return;
        if (!open)
            updatePosition();
        setOpen(!open);
    };
    const handleEmojiSelect = (emojiObject) => {
        onEmojiSelect(emojiObject.native);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(SmileOutlined, { ref: triggerRef, className: styles.trigger, onClick: handleToggle }),
        open && createPortal(React.createElement("div", { ref: pickerRef, className: styles.picker, style: { top: position.top, left: position.left }, onClick: (e) => e.stopPropagation() },
            React.createElement(Picker, { data: pickerData, onEmojiSelect: handleEmojiSelect, theme: "light" })), document.body)));
};
export default EmojiPickerPortal;
